import type { MaritalStatuses } from 'src/circuits/transmission-circuit/shared/transmission-circuit.const'
import { MARITAL_STATUSES } from 'src/circuits/transmission-circuit/shared/transmission-circuit.const'
import type {
  AuthPrecision,
  UserRole,
} from 'src/tpbp-core/models/auth/auth.types'
import {
  AUTH_PRECISIONS,
  USER_ROLES,
} from 'src/tpbp-core/models/auth/auth.types'
import type {
  PersonModel,
  RelationModel,
} from 'src/tpbp-json-api-handler/models/models'

export function verifyIsAdvisor(currentUserRole: UserRole): boolean {
  return currentUserRole === USER_ROLES.ADVISOR
}

export function verifyIsSelfcare(currentUserRole: UserRole): boolean {
  return currentUserRole === USER_ROLES.SELF_CARE
}

export function verifyHasLinxo(currentUserRole: UserRole): boolean {
  return verifyIsSelfcare(currentUserRole)
}

export function isCurrentUserSelectedInDashboard({
  userIdsForIndicators,
  currentUserId,
}: {
  userIdsForIndicators: string[]
  currentUserId: string
}): boolean {
  return userIdsForIndicators.length === 1 && userIdsForIndicators[0]
    ? userIdsForIndicators[0] === currentUserId
    : false
}

export function getPersonFromId(
  currentUserRelations: RelationModel[],
  id: string,
) {
  return currentUserRelations?.find((relation) => relation._subject.id === id)
    ?._subject
}

export function getAllPersons({
  user,
  partner,
  children,
}: {
  user: PersonModel
  partner?: PersonModel
  children: PersonModel[]
}) {
  return [user, partner, ...children].filter(Boolean) as PersonModel[]
}

export function getUsersFullnames(
  users: {
    id: string
    fullName: string
  }[],
) {
  return Object.fromEntries(users.map((p) => [p.id, p.fullName]))
}

export function isPartnerFiscal(maritalStatus: MaritalStatuses) {
  return (
    maritalStatus === MARITAL_STATUSES.married ||
    maritalStatus === MARITAL_STATUSES.pacs
  )
}

export function mustFollowAdvice(precisions: AuthPrecision[]): boolean {
  return precisions.includes(AUTH_PRECISIONS.MUST_FOLLOW_ADVICE)
}
